module.exports = __webpack_public_path__ + "images/kihnu/android-icon-36x36.png";